import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex, GridItem } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { globalRequirementTemplateBuilder } from '../../../../../../redux/reducer';
import PolicyTypeBadge from '../PolicyTypeBadge';

function TemplatePolicyTypes({ templateRequirementBlocks }) {
  const { templateStatusFilter } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplates);

  const isArchived = !!templateStatusFilter.archived;
  const isDraft = !!templateStatusFilter.drafts;

  const getLayerStyle = policyType => (policyType === ('OCIP' || 'CCIP') ? 'approved' : 'active');

  const templateBlockProperties = templateRequirementBlocks
    .map(({ requirementTemplateBlockProperties }) => requirementTemplateBlockProperties);

  const renderPolicyTypes = () => templateBlockProperties.map(property => {
    if (!property[0]) {
      return null;
    }

    const propertyType = property[0].requirementType;
    if (propertyType === 'insurance_policy_type_property') {
      const { policyTypeDisplayName } = property[0];
      return (
        <Box mb={2} mr={3}>
          <PolicyTypeBadge
            key={policyTypeDisplayName}
            layerStyle={(isArchived || isDraft) ? 'archived' : getLayerStyle(policyTypeDisplayName)}
            policyType={policyTypeDisplayName}
          />
        </Box>
      );
    }

    return null;
  });

  return (
    <GridItem colSpan={11} w="100%">
      <Flex flexWrap="wrap">
        {renderPolicyTypes()}
      </Flex>
    </GridItem>
  );
}

TemplatePolicyTypes.propTypes = {
  templateRequirementBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};

export default TemplatePolicyTypes;
